import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import localeFr from '@angular/common/locales/fr';
import {
  ApplicationConfig,
  LOCALE_ID,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { MAT_DATE_LOCALE, provideNativeDateAdapter } from '@angular/material/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { routes } from './app.routes';
import { authInterceptor } from './core/auth.interceptor';
import { AuthService } from './core/auth.service';
import { ConfigService } from './core/config.service';
import { ThemeService } from './core/theme.service';
import { FrenchPaginatorIntl } from './shared/french-paginator';

registerLocaleData(localeFr);

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideNativeDateAdapter(),
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
    { provide: MatPaginatorIntl, useClass: FrenchPaginatorIntl },
    // Configuration publique de l'instance, puis MSAL (traitement du retour de connexion).
    provideAppInitializer(async () => {
      // inject() uniquement avant le premier await (contexte d'injection).
      // Thème choisi par l'utilisateur, appliqué avant le premier affichage.
      inject(ThemeService);
      const config = inject(ConfigService);
      const auth = inject(AuthService);
      await auth.init(await config.load());
    }),
  ],
};
